import { Method } from 'axios'
import Constants from 'expo-constants'

const ENDPOINTS: Record<
  string,
  { [key: string]: { endpoint: string; method: Method } }
> = {
  'zet-app': {
    getBrandsCategory: {
      endpoint: 'zet/getCategory',
      method: 'GET',
    },
    getPincodeCheck: {
      endpoint: 'customer/brands',
      method: 'GET',
    },
    getPartnersDataByCategoryId: {
      endpoint: 'zet/getBrands',
      method: 'GET',
    },
    getBrandDataByPartnerId: {
      endpoint: 'getBrandComms/updated',
      method: 'POST',
    },
    getVariantDetailsById: {
      endpoint: 'variants',
      method: 'GET',
    },
    getUserContext: {
      endpoint: 'app/zetUser',
      method: 'GET',
    },
    getPincodeSuggestions: {
      endpoint: 'user/pincode/suggest',
      method: 'GET',
    },
    getCustomerCount: {
      endpoint: 'customer/getCustomerCount/v2',
      method: 'GET',
    },
    fetchLeads: {
      endpoint: '/leads',
      method: 'GET',
    },
    fetchDashboard: {
      endpoint: '/brand/getAgentDashboard',
      method: 'GET',
    },
    getCreditReport: {
      endpoint: 'public/customer/getBureauDetails',
      method: 'GET',
    },
    getCreditScoreUrl: {
      endpoint:
        'customer/generateShareLink/v2?linkType=globalShareLink&isCreditCheck=true&customerAdditionSource=creditScoreCheck',
      method: 'GET',
    },
  },
  'my-teams': {
    getBrandsCategory: {
      endpoint: 'enterprise/subAgent/getCategories',
      method: 'GET',
    },
    getPincodeCheck: {
      endpoint: 'enterprise/subAgent/getBrands',
      method: 'GET',
    },
    getPartnersDataByCategoryId: {
      endpoint: 'enterprise/subAgent/brands/category',
      method: 'GET',
    },
    getBrandDataByPartnerId: {
      endpoint: 'enterprise/subAgent/getBrandComms',
      method: 'POST',
    },
    getUserContext: {
      endpoint: 'enterprise/subAgent/getDetails',
      method: 'GET',
    },
    getPincodeSuggestions: {
      endpoint: 'user/pincode/suggest',
      method: 'GET',
    },
    getCustomerCount: {
      endpoint: '/enterprise/subAgent/getCustomerCount',
      method: 'GET',
    },
    fetchLeads: {
      endpoint: '/enterprise/subAgent/leads',
      method: 'GET',
    },
    fetchDashboard: {
      endpoint: '/enterprise/subAgent/brand/dashboard',
      method: 'GET',
    },
  },
}

export const APP_NAME: string = Constants?.expoConfig?.slug as never

export default ENDPOINTS
